"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = exports.LogoIconSvg = void 0;
var _react = _interopRequireDefault(require("react"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
const LogoIconSvg = () => {
  return /*#__PURE__*/_react.default.createElement("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "85 0 30 30",
    role: "img"
  }, /*#__PURE__*/_react.default.createElement("title", null, "PetSure Logo Paw"), /*#__PURE__*/_react.default.createElement("path", {
    d: "M101 10s-2.836-.525-8.743 2.888c0 0-2.3 1.523-3.518 3.072s-2.074 4.043.55 7.285c0 0 .656.565 2.284.696s4.9.814 6.774 2.547 2.705 2.232 3.597 2.44 2.914-.708 3.624-7.22-1.208-8.953-1.523-9.74-2.312-1.946-3.046-1.97"
  }), /*#__PURE__*/_react.default.createElement("path", {
    d: "M91.32 9.575s-1.08-.28-1.392-.92c-.245-.505.36-1.74.5-1.916s.595-1.566.902-2.092 1.094-1.55 1.978-1.768 1.225-.55 2.302-.455 1.164 2.293 1.12 2.494-.55 2.442-1.068 2.853c0 0-.945 1.356-1.636 1.672s-.984.85-1.855.55c-.818-.28-.7-.324-.84-.42"
  }), /*#__PURE__*/_react.default.createElement("path", {
    d: "M97.655 5.894s1.707 1.313 2.258 1.378 1.13-.145 1.536-.328 1.845-.698 2.547-.525c1.05.258 1.916-1.536 1.956-2.074s-.276-2.14-.394-2.4S105.322.532 104.3 0h-1.418s-1.33 0-3.046 2.232l-1.8 2.268c-.37.36-.564 1.13-.38 1.405m10.448-.2c.14-.007 1.693-.538 2.836-.368s1.3 1.64 1.3 1.706.247 1.363.08 2.22c-.06.3-1.063 2.678-1.103 2.783l-.486 1.5c-.052.026-.512 1.55-1.798.486s-1.523-.748-1.864-1.916c0 0-.13-2.35-.735-3.164s.762-3.203 1.772-3.256m3.784 9.827s-1.378-.276-2.534.748-1.628 4.096-1.628 4.096-.052 1.97.565 2.64c0 0 .735.394 1.076.46s.854.683 1.234.657.775.2 1.9-2.586.932-2.704.774-3.374-.647-2.464-1.378-2.64"
  }));
};
exports.LogoIconSvg = LogoIconSvg;
var _default = exports.default = LogoIconSvg;